import * as React from "react";
import Amount from "../../../model/common/Amount";
import QuantityPicker from "./QuantityPicker";

interface Props {
	/**
	 * Item name
	 */
	name: string;
	/**
	 * Item price
	 */
	price: Amount;
	/**
	 * Item quantity
	 */
	quantity: number;
	/**
	 * On decrement click
	 */
	onDecrementClick: () => any
	/**
	 * On increment click
	 */
	onIncrementClick: () => any
	/**
	 * On remove click
	 */
	onRemove?: () => any
	/**
	 * Decrement limit (default = 1)
	 */
	decrementLimit?: number
}

export default class ItemQuantityPicker extends React.Component<Props, {}> {
	render() {
		const {name, price, quantity} = this.props;
		return (
			<div className={"quote-items-row"}>
				<div className={"item-name"}>{name}</div>
				<div className={"item-price"}>{price.format()}</div>
				<div className={"quantity-picker"}>
					<QuantityPicker quantity={quantity}
									decrementLimit={this.props.decrementLimit}
									onDecrementClick={this.props.onDecrementClick}
									onIncrementClick={this.props.onIncrementClick}/>
					{
						this.props.onRemove &&
						<span className={"icon red"} onClick={this.props.onRemove}>
							<i className={"fa fa-times fa-fw"}/>
						</span>
					}
				</div>
			</div>
		)
	}
}
